var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff9240;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.61,0c-2.09,0-3.73,1.63-3.73,3.72s1.67,3.72,3.73,3.72,3.73-1.7,3.73-3.72-1.67-3.72-3.73-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.57,24.52c0,5.14-4.21,9.36-9.39,9.41h-1.09v6.07h1.1c8.53,0,15.46-6.95,15.46-15.48v-14.91h-6.09v14.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.82,9.09c-8.56,0-15.52,6.92-15.52,15.43s6.96,15.48,15.52,15.48,15.46-6.95,15.46-15.48-6.94-15.43-15.46-15.43ZM147.19,24.52c0,5.19-4.21,9.41-9.38,9.41s-9.43-4.22-9.43-9.41,4.23-9.36,9.43-9.36,9.38,4.2,9.38,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.82,0v12.25c-2.68-2.03-5.99-3.16-9.38-3.16-8.56,0-15.52,6.92-15.52,15.43s6.96,15.48,15.52,15.48,15.46-6.95,15.46-15.48V0h-6.09ZM180.82,24.52c0,5.19-4.21,9.41-9.38,9.41s-9.43-4.22-9.43-9.41,4.23-9.36,9.43-9.36,9.38,4.2,9.38,9.36Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.82,9.09c-8.56,0-15.52,6.92-15.52,15.43s6.96,15.48,15.52,15.48,15.46-6.95,15.46-15.48-6.94-15.43-15.46-15.43ZM147.19,24.52c0,5.19-4.21,9.41-9.38,9.41s-9.43-4.22-9.43-9.41,4.23-9.36,9.43-9.36,9.38,4.2,9.38,9.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.82,0v12.25c-2.68-2.03-5.99-3.16-9.38-3.16-8.56,0-15.52,6.92-15.52,15.43s6.96,15.48,15.52,15.48,15.46-6.95,15.46-15.48V0h-6.09ZM180.82,24.52c0,5.19-4.21,9.41-9.38,9.41s-9.43-4.22-9.43-9.41,4.23-9.36,9.43-9.36,9.38,4.2,9.38,9.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLogo);
export default __webpack_public_path__ + "static/media/TextLogo.49818da561c38adfaffdbd7585f7c63c.svg";
export { ForwardRef as ReactComponent };